import { IHttpApi, IModel, IModelResponse } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';

const defaultConfig: TSwitchToAgentModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'homeowners',
  pathApi: '/v1/set-as-specialist/',
};

export type TSwitchToAgentModel = IModel<ISwitchToAgentRequest, ISwitchToAgentResponse>;

export interface ISwitchToAgentRequest {
}

export interface ISwitchToAgentResponseSchema {
}

export interface ISwitchToAgentResponse extends IModelResponse<ISwitchToAgentResponseSchema> {
  Code: 200;
}

export function createModel(config: Partial<TSwitchToAgentModel>): TSwitchToAgentModel {
  return {
    ...defaultConfig,
    ...config,
  };
}

export interface ISwitchToAgentDependencies {
  logger: ILogger;
  httpApi: IHttpApi;
}

export const switchToAgent = async (
  dependencies: ISwitchToAgentDependencies,
  parameters?: ISwitchToAgentRequest,
) => {
  const { httpApi, logger } = dependencies;

  const requestConfig = {
    withCredentials: true,
    headers: [[ 'Content-Type', 'application/json' ]] as [string, string][],
  };

  try {
    const { response } = await httpApi.fetch(createModel({ parameters }), { requestConfig });

    return response;
  } catch (error) {
    logger.error(
      error,
      {
        description: 'Homeowners v1/set-as-specialist rejection error',
        requestParameters: { ...parameters },
      },
    );

    return Promise.resolve({ data: { } });
  }
};
